<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2022-06-20 17:52:31
-->
<template>
  <el-select
    class="component__language-selector"
    :style="{ width }"
    :placeholder="placeholder"
    :multiple="multiple"
    :disabled="disabled"
    :collapse-tags="collapseTags"
    v-model="inputValue"
    :filter-method="filterSearch"
    @change="handleChanged"
    size="small"
    filterable
  >
    <template v-if="isFiltering">
      <el-option
        v-for="item in filterOptions"
        :key="item.code"
        :label="item.text"
        :value="item.code"
        :disabled="checkItemReadOnly(item.code)"
      >
        <span style="float: left">{{ item.text }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">{{
          item.code
        }}</span>
      </el-option>
    </template>
    <template v-else>
      <el-option
        key
        label="全部"
        v-if="showAllOption && !multiple"
        value
      ></el-option>
      <el-option-group
        v-for="group in allLanguagesGroups"
        :key="group.label"
        :label="group.label"
      >
        <el-option
          v-for="item in group.languages"
          :key="item.code"
          :label="item.text"
          :value="item.code"
          :disabled="checkItemReadOnly(item.code)"
        >
          <span style="float: left">{{ item.text }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{
            item.code
          }}</span>
        </el-option>
      </el-option-group>
    </template>
  </el-select>
</template>

<script>
import { cacheProxy } from "../data/cache";
import store, { userState } from "../store/index";
import { mapGetters } from "vuex";
import { isBlank, stringUti } from "../utils/String";

const RENCENTLY_USED_LANGEAGES_NAME = "_RCT_LANS";

// Read used languages (for current user) map from local storage
function readUsedLanguagesFromLocal() {
  let languages;
  let languagesText = window.localStorage.getItem(
    RENCENTLY_USED_LANGEAGES_NAME
  );
  if (!isBlank(languagesText)) {
    try {
      languages = JSON.parse(languagesText);
    } catch (err) {
      languages = {};
    }
  }
  return languages || {};
}

// Initialize used language list for store
function initializeUsedLanguagesForStore() {
  console.log(
    "#-# initializeUsedLanguagesForStore",
    store.state.user,
    store.state.user.userInfo
  );
  if (!store.state.user || !store.state.user.userInfo) {
    return null;
  }

  const userId = store.state.user.userInfo.id;
  const languages = readUsedLanguagesFromLocal();
  const cachedUserLanguage = languages[userId] || ["zh", "en"];
  console.log("#-# step.1", cachedUserLanguage);
  store.dispatch("setUsedLanguages", cachedUserLanguage);
}

// Read recently used langauges list from local store;
store.watch(
  (_, g) => g.isPageUserLoadded,
  (newValue) => {
    if (newValue) {
      initializeUsedLanguagesForStore();
    }
  }
);
initializeUsedLanguagesForStore();

// Update local storage when used langauges changed.
store.watch(
  (s) => s.user.recentlyUsedLanguages,
  (newValue) => {
    if (!store.state.user || !store.state.user.userInfo) return null;
    const userId = store.state.user.userInfo.id;
    const languages = readUsedLanguagesFromLocal();
    languages[userId] = newValue || [];
    window.localStorage.setItem(
      RENCENTLY_USED_LANGEAGES_NAME,
      JSON.stringify(languages)
    );
  }
);

import { getLangauges } from "../api/configure";
import Pinyin from "tiny-pinyin";

async function languageGetterFunc() {
  const dict = await getLangauges();
  return dict.map((item) => {
    return {
      code: item.code,
      text: item.text,
      py: (Pinyin.convertToPinyin(item.text, " ", true) || "")
        .split(" ")
        .reduce((p, c) => p + (c.length > 0 ? c[0] : ""), ""),
    };
  });
}
const languageGetter = cacheProxy(languageGetterFunc);

export default {
  props: {
    width: {
      type: String,
    },
    value: {
      type: [String, Array],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    showAllOption: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonlyValues: {
      type: Array,
    },
    collapseTags: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      languageGetter,
      allLanguages: null,
      inputValue: this.value,

      filterText: null,
      filterOptions: [],
    };
  },
  methods: {
    checkItemReadOnly(itemValue) {
      return !!itemValue && (this.readonlyValues || []).indexOf(itemValue) > -1;
    },
    handleChanged(value) {
      this.$emit("change", value);
      if (!!value) {
        this.filterText = null;
        let values = value instanceof Array ? value : [value];
        values.$$each((v) => {
          this.$store.dispatch("addUsedLanguage", v);
        });
      }
    },
    filterSearch(arg1, arg2, arg3) {
      this.filterText = arg1;
    },
  },
  computed: {
    ...mapGetters(["usedLangauges"]),
    allLanguagesGroups() {
      if (!this.allLanguages) return [];

      const groups = [
        {
          label: "常用语言",
          languages: (this.usedLangauges || []).reduce((pre, cur) => {
            const lan = this.allLanguages.$$first((l) => l.code === cur);
            !!lan && pre.push(lan);
            return pre;
          }, []),
        },
        {
          label: "其他语言",
          languages: this.allLanguages.filter(
            (l) => this.usedLangauges.indexOf(l.code) < 0
          ),
        },
      ];
      return groups;
    },
    isFiltering() {
      return !!this.filterText && !stringUti.isBlank(this.filterText);
    },
  },
  watch: {
    value(newVal, oldVal) {
      this.inputValue = newVal;
    },
    inputValue(newVal, oldVal) {
      this.$emit("input", newVal);
    },
    filterText(newVal, oldVval) {
      if (!stringUti.isBlank(newVal)) {
        const lowSearch = newVal.toLocaleLowerCase();
        this.filterOptions = this.allLanguages.filter((item) => {
          return (
            item.code.toLocaleLowerCase().indexOf(lowSearch) > -1 ||
            item.py.indexOf(lowSearch) > -1 ||
            item.text.toLocaleLowerCase().indexOf(lowSearch) > -1
          );
        });
      } else {
        this.filterOptions = [];
      }
    },
  },
  async mounted() {
    const langauges = await languageGetter.get();
    this.allLanguages = langauges;
  },
};
</script>

<style lang="scss">
.component__language-selector {
  .el-select__tags {
    .el-select__input {
      border: unset;
    }
  }
}
</style>